import { GTMEvent } from '../GTM'
import { MenuTrackingData } from '@corratech/pylot-tag-manager/src/hooks/useMenuTracking'

export const pushMenuClick = (data: MenuTrackingData): GTMEvent => {
    const eventData = {
        event: 'menu_click',
        ...data
    }
    return eventData
}
